export default {"src":"/_next/static/media/galvan_logo.a40600c9.svg","height":49,"width":48};